<template>
    <div class="card mt-3">
        <div class="card-header">
            <h5 class="d-inline">Upload Group {{ uploadGroup.uploadGroupId }}</h5>
            <button
                class="btn btn-sm btn-light float-right d-inline py-0"
                @click="removeUploadGroup">
                &times; Remove
            </button>
        </div>
        <div class="card-body">
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Upload Interval (in seconds)</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': uploadIntervalError }"
                        v-model="uploadGroup.uploadInterval"
                        @change="validateUploadInterval" />
                    <div class="invalid-feedback">Integers only</div>
                </div>
            </div>
            <polling-group
                v-for="pollingGroup in modbusConfig.pollingGroupArr"
                :key="pollingGroup.pollingGroupId"
                :pollingGroup="pollingGroup"
                :uploadGroup="uploadGroup"
                :uploadGroupArr="modbusConfig.uploadGroupArr"
                @statusReportingChanged="updateStatusReporting($event)"></polling-group>
        </div>
    </div>
</template>

<script>
import PollingGroup from './PollingGroup.vue'

export default {
    components: {
        'polling-group': PollingGroup
    },
    data() {
        return {
            uploadIntervalError: false
        }
    },
    props: ['modbusConfig', 'uploadGroup'],
    methods: {
        removeUploadGroup() {
            this.$emit('uploadGroupRemoved', { uploadGroupId: this.uploadGroup.uploadGroupId })
        },
        updateStatusReporting($event) {
            this.$emit('statusReportingChanged', {
                value: $event.value,
                pollingGroupId: $event.pollingGroupId,
                uploadGroupId: this.uploadGroup.uploadGroupId
            })
        },
        validateUploadInterval() {
            if(!/^\d+$/.test(this.uploadGroup.uploadInterval)) {
                this.uploadIntervalError = true
            } else {
                this.uploadIntervalError = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/upload-group/UploadGroup.vue